import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension';

import { isDev } from './utils';
import session from './actions/session';
import districts from './actions/districts';
import schools from './actions/schools';
import users from './actions/users';
import uploads from './actions/uploads';
import app from './actions/app';
import reports from './actions/reports';

const reducers = combineReducers( {app, session, districts, schools, users, uploads, reports} )

const composeFunction = isDev()
  ? composeWithDevTools({ trace: true, traceLimit: 25 })
  : compose;


const store =  createStore(reducers, composeFunction(applyMiddleware(thunk)));
export default store;

